import { useState } from 'react';
import SectionHeading from '@/pages/home/components/SectionHeading';
import { topics } from '@/mocks/home';

export default function TopicBoard() {
  const [liked, setLiked] = useState<Record<number, boolean>>({});

  const toggleLike = (id: number) => {
    setLiked((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  return (
    <section id="topics" className="scroll-mt-28 border-b border-background-200 bg-background-50">
      <div className="mx-auto max-w-[1280px] px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <SectionHeading
            no="03"
            english="Forum Picks"
            title="讨论区精选"
            desc="不只看热闹，也要有话说。这里挑出近期讨论度最高的帖子，观点比瓜本身更耐嚼。"
          />
          <a
            href="#community"
            className="hidden cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-foreground-300 px-6 py-3 font-label text-sm text-foreground-800 transition-colors hover:bg-background-100 md:flex"
          >
            <i className="ri-add-line" />
            发起新话题
          </a>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-x-12 lg:grid-cols-2">
          {topics.map((topic, index) => (
            <article
              key={topic.id}
              className="flex flex-col border-b border-background-200 py-6 first:border-t first:border-background-200 animate-fadeUp"
              style={{ animationDelay: `${index * 50}ms` }}
            >
              <div className="flex items-center gap-3">
                <span className="rounded-full bg-secondary-100 px-2.5 py-1 font-label text-[11px] text-secondary-900">{topic.category}</span>
                {topic.pinned && (
                  <span className="flex items-center gap-1 rounded-full bg-primary-100 px-2.5 py-1 font-label text-[11px] text-primary-700">
                    <i className="ri-pushpin-2-fill" />
                    置顶
                  </span>
                )}
                <span className="ml-auto font-label text-[11px] text-foreground-500">最后回复 {topic.lastReply}</span>
              </div>

              <a href="#community" className="group mt-3 cursor-pointer">
                <h3 className="font-heading text-lg font-bold leading-snug text-foreground-900 transition-colors group-hover:text-primary-700 md:text-xl">
                  {topic.title}
                </h3>
              </a>

              <div className="mt-4 flex items-center gap-4">
                <div className="flex items-center gap-2">
                  <span className="flex h-7 w-7 items-center justify-center rounded-full bg-background-200 font-label text-[11px] font-bold text-foreground-700">
                    {topic.author.slice(0, 1)}
                  </span>
                  <span className="text-xs text-foreground-600">{topic.author}</span>
                </div>
                <span className="ml-auto flex items-center gap-1.5 font-label text-xs text-foreground-500">
                  <i className="ri-chat-1-line" />
                  {topic.replies}
                </span>
                <button
                  type="button"
                  onClick={() => toggleLike(topic.id)}
                  className={
                    'flex cursor-pointer items-center gap-1.5 whitespace-nowrap font-label text-xs transition-colors ' +
                    (liked[topic.id] ? 'text-primary-600' : 'text-foreground-500 hover:text-primary-600')
                  }
                >
                  <i className={liked[topic.id] ? 'ri-heart-fill' : 'ri-heart-line'} />
                  {topic.likes + (liked[topic.id] ? 1 : 0)}
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}